module.exports = __webpack_public_path__ + "static/media/assessment-score-banner.ab5bf8c4.svg";